import Api from "@src/api";

export const workReportNewEquipmentApi = {
  createReport(params) {
    return Api().post("NewWorkReport/CreateWorkReport", params);
  },
  updateReport(id, params) {
    return Api().put(`NewWorkReport/UpdateWorkReport/${id}`, params);
  },
  uploadImage(formData) {
    return Api().post(`/FileUpload/Image`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  uploadFileAttach(formData) {
    return Api().post(`FileUpload/WorkReportAttachment`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getDetail(id) {
    return Api().get(`NewWorkReport/GetWorkReportById/${id}`);
  },
  getApprover() {
    return Api().get(`NewWorkReport/GetApprovers`);
  },
  changeStatus(body) {
    return Api().put(`NewWorkReport/UpdateStatusWorkReport/${body.id}`, body);
  },
  searchUser(data) {
    return Api().get(`UserInfo/SearchUserByKeyword`, {
      params: data,
    });
  },
  dowloadAllFile(id) {
    return Api().get("WorkReport/download-all-attachments/" + id, {
      responseType: "blob",
    });
  },
};
